import { NavigationData } from "@ubisolutions/core";

export const WORKSPACE_NAVIGATION: NavigationData = {
    settings: {
        prefix: "workspace",
    },
    routes: [
        {
            key: "routing.workspace.dashboard._title",
            icon: "dashboard",
            route: "dashboard",
        },
        {
            key: "assets.asset.plural",
            icon: "assets.asset.icon",
            route: "assets",
            allPermissions: ["Asset"],
        },
        // {
        //     key: "routing.workspace.logistical-centers._title",
        //     icon: "home_work",
        //     route: "logistical-centers",
        //     allPermissions: ["LogisticalCenter"],
        // },
        {
            key: "routing.workspace.map.outdoor._title",
            icon: "travel_explore",
            route: "map",
            allPermissions: ["Asset"],
        },
        {
            key: "routing.workspace.indoor-location._title",
            route: "indoor-location",
            icon: "home",
            allPermissions: [
                "LogisticalCenter",
                "Building",
                "Floor",
                "Room",
                "Asset",
            ],
        },
        {
            key: "routing.workspace.outdoor-location._title",
            route: "outdoor-location",
            icon: "location_on",
            allPermissions: ["Asset"],
        },
        {
            key: "routing.workspace.alerts._title",
            icon: "notifications",
            route: "alerts",
        },
        {
            key: "routing.workspace.track-link._title",
            icon: "view_list",
            route: "track-link/items",
            anyPermission: ["TrackLink"],
        },
    ],
};
